import { types, getEnv, getSnapshot, flow as flow$1 } from 'mobx-state-tree';
import { flow, values } from 'mobx';
import parseISO from 'date-fns/parseISO';
import isValid from 'date-fns/isValid';
import _lightFormat from 'date-fns/lightFormat';
import md5 from 'md5';
import LRU from 'lru-cache';

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : String(i);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// import { flow } from 'mobx';

/*
 *	Collection
 *
 *	A model for a collection of items
 */

var Collection = types.model("Collection", {})
// allow collections to be created with blank arrays or undefined
.preProcessSnapshot(function (snapshot) {
  if (snapshot === undefined || Array.isArray(snapshot)) {
    return {
      collection: snapshot || []
    };
  }
  return snapshot;
}).views(function (self) {
  return {
    get isEmpty() {
      return self.length === 0;
    },
    get length() {
      return self.collection.length;
    }
  };
}).actions(function (self) {
  return {
    setItems: function setItems() {
      var collection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      self.collection = collection;
    },
    addItem: function addItem(item) {
      self.collection.push(item);
    },
    /**
     * Add multiple items to the end of the collection
     * @param {*} items
     */
    addItems: function addItems(items) {
      self.collection = [].concat(_toConsumableArray(self.collection), _toConsumableArray(items));
    },
    prependItem: function prependItem(item) {
      self.collection.unshift(item);
    },
    /**
     * Add multiple items to the beginning of the collection
     * @param {*} items
     */
    prependItems: function prependItems(items) {
      self.collection = [].concat(_toConsumableArray(items), _toConsumableArray(self.collection));
    },
    dequeueItem: function dequeueItem() {
      self.collection.shift();
    },
    popItem: function popItem() {
      self.collection.pop();
    },
    clearItems: function clearItems() {
      self.collection.clear();
    },
    filterItems: function filterItems(comparator) {
      return self.collection.filter(comparator);
    },
    findItem: function findItem(prop, val) {
      return self.collection.find(function (item) {
        return prop ? item[prop] === val : item === val;
      });
    },
    deleteItem: function deleteItem(key, value) {
      var toRemove = self.findItem(key, value);
      self.collection.remove(toRemove);
    },
    map: function map(mapper) {
      return self.collection.map(mapper);
    }
  };
});
var createCollection = function createCollection(name, arrayOfModel) {
  return types.compose(Collection, types.model("".concat(name, "Collection"), {
    collection: types.array(arrayOfModel)
  }));
};

/*
 *	CreateAsyncFlow
 *
 *	creates a model for handling asynchronous operations
 *	automatically sets loading the flag if there is an operation in progress
 */

var CreateAsyncActionsFlow = function CreateAsyncActionsFlow(actionsObj) {
  return types.model('AsyncFlow', {})
  // the loading flag doesn't need to be persisted
  ["volatile"](function (self) {
    return {
      loading: false,
      __defaultFn: function __defaultFn(res) {
        return res;
      },
      __beforeResponseSuccess: function __beforeResponseSuccess(res) {
        return res;
      },
      __afterResponseSuccess: function __afterResponseSuccess(res) {
        return res;
      },
      __beforeError: function __beforeError(res) {
        return res;
      },
      __afterError: function __afterError(res) {
        return res;
      },
      __finally: function __finally(res) {
        return res;
      },
      __onSuccess: function __onSuccess(res) {
        return res;
      },
      __onError: function __onError(res) {
        return res;
      }
    };
  }).actions(function (self) {
    var mstActions = Object.keys(actionsObj).reduce(function (actions, actionName) {
      return _objectSpread2(_objectSpread2({}, actions), {}, _defineProperty(_defineProperty({}, actionName, function () {
        return self["__".concat(actionName)].apply(self, arguments);
      }), "__".concat(actionName), flow( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _len,
          args,
          _key,
          _actionsObj$actionNam,
          asyncAction,
          response,
          error,
          _args = arguments;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              for (_len = _args.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = _args[_key];
              }
              _context.prev = 1;
              self.setLoading(true);
              // curry the action function with self
              // give args as well in case devs want to do something extra with them
              // not sure why they would need to though
              asyncAction = (_actionsObj$actionNam = actionsObj[actionName]).action.apply(_actionsObj$actionNam, [self].concat(args)); // call the curried async action with any passed args and self
              // this means that if no params are passed, only self will be passed as a param
              _context.next = 6;
              return asyncAction.apply(void 0, args.concat([self]));
            case 6:
              response = _context.sent;
              _context.next = 9;
              return self.__beforeResponseSuccess(response, self);
            case 9:
              response = _context.sent;
              _context.next = 12;
              return actionsObj[actionName].onSuccess(self)(response);
            case 12:
              _context.next = 14;
              return self.__afterResponseSuccess(response, self);
            case 14:
              _context.next = 26;
              break;
            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](1);
              console.error(_context.t0);
              _context.next = 21;
              return self.__beforeError.apply(self, [_context.t0].concat(args, [self]));
            case 21:
              error = _context.sent;
              _context.next = 24;
              return actionsObj[actionName].onError(self)(error);
            case 24:
              _context.next = 26;
              return self.__afterError.apply(self, [_context.t0].concat(args, [self]));
            case 26:
              _context.prev = 26;
              // stop the loading no matter what
              self.setLoading(false);
              _context.next = 30;
              return self.__finally(self);
            case 30:
              return _context.finish(26);
            case 31:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 16, 26, 31]]);
      }))));
    }, {});
    return _objectSpread2(_objectSpread2({}, mstActions), {}, {
      setLoading: function setLoading(isLoading) {
        // need to do this because when we generate actions like this,
        // they become out of context of the actions section of the model
        // which prevents us from mutating data.  In MST, all data must be
        // mutated through actions
        self.loading = isLoading;
      },
      beforeResponseSuccess: function beforeResponseSuccess(beforeResponseSuccessFn) {
        self.__beforeResponseSuccess = beforeResponseSuccessFn;
      },
      afterResponseSuccess: function afterResponseSuccess(afterResponseSuccessFn) {
        self.__afterResponseSuccess = afterResponseSuccessFn;
      },
      beforeError: function beforeError(beforeErrorFn) {
        self.__beforeError = beforeErrorFn;
      },
      afterError: function afterError(afterErrorFn) {
        self.__afterError = afterErrorFn;
      },
      "finally": function _finally(finallyFn) {
        self.__finally = finallyFn;
      },
      onSuccess: function onSuccess(successFn) {
        self.__onSuccess = successFn;
      },
      onError: function onError(errorFn) {
        self.__onError = errorFn;
      },
      unbindBeforeResponseSuccess: function unbindBeforeResponseSuccess() {
        self.__beforeResponseSuccess = self.__defaultFn;
      },
      unbindAfterResponseSuccess: function unbindAfterResponseSuccess() {
        self.__afterResponseSuccess = self.__defaultFn;
      },
      unbindBeforeError: function unbindBeforeError() {
        self.__beforeError = self.__defaultFn;
      },
      unbindAfterError: function unbindAfterError() {
        self.__afterError = self.__defaultFn;
      },
      unbindFinally: function unbindFinally() {
        self.__finally = self.__defaultFn;
      },
      unbindOnSuccess: function unbindOnSuccess() {
        self.__onSuccess = self.__defaultFn;
      },
      unbindOnError: function unbindOnError() {
        self.__onError = self.__defaultFn;
      },
      unbindLifeCycleHooks: function unbindLifeCycleHooks() {
        var defaultLifeCycleFn = function defaultLifeCycleFn(res) {
          return res;
        };
        self.beforeResponseSuccess(defaultLifeCycleFn);
        self.afterResponseSuccess(defaultLifeCycleFn);
        self.beforeError(defaultLifeCycleFn);
        self.afterError(defaultLifeCycleFn);
        self["finally"](defaultLifeCycleFn);
      }
    });
  });
};

/*
 *	Notification
 *
 *	A model for a Notification
 */

var Notification = types.model('Notification', {
  message: types.optional(types.string, 'Unknown error'),
  context: types.maybeNull(types.enumeration(['good', 'bad', 'warning'])),
  // in ms
  timeout: types.optional(types.number, 5000)
});

/*
 *	NotificationHandler
 *
 *	A model that is in charge of displaying system messages such as, but not limited to,  error or success messages
 */

var NotificationHandler = types.compose('NotificationHandler', createCollection('Notification', Notification), types.model({}).views(function (self) {
  return {
    filterContext: function filterContext(context) {
      return self.filterItems(function (item) {
        return item.context === context;
      });
    },
    get errors() {
      return self.filterContext('bad');
    },
    get warnings() {
      return self.filterContext('warning');
    },
    get successes() {
      return self.filterContext('good');
    },
    get notifications() {
      return self.collection;
    }
  };
}).actions(function (self) {
  return {
    addNotification: function addNotification(notification) {
      self.prependItem(notification);
    },
    dismissNotification: function dismissNotification() {
      self.dequeueItem();
    },
    clearNotifications: function clearNotifications() {
      self.clearItems();
    }
  };
}));

/**
 * SeatMetaInfo Model
 * Models what meta information should look like for a seat in a venue
 *
 * @typedef SeatMetaInfo information about the venue that aids in filtering
 * @property {Boolean} [available=false] whether or not this is available
 * @property {Boolean} [companion=false] whether or not this is a companion seat
 * @property {Boolean} [handicapped=false] whether or not this is a handicapped seat
 * @property {Boolean} [locked=false] whether or not this is locked a locked seat
 * @property {Boolean} [recommended=false] whether or not this seat is recommended to user
 * @property {Boolean} [reserved=false] whether or not this seat is reserved
 */
var SeatMetaInfo = types.model('SeatMetaInfo', {
  available: types.optional(types["boolean"], false),
  companion: types.optional(types["boolean"], false),
  handicapped: types.optional(types["boolean"], false),
  recommended: types.optional(types["boolean"], false),
  reserved: types.optional(types["boolean"], false)
}).actions(function (self) {
  return {
    /**
     * Resets to defaults
     */
    reset: function reset() {
      self.available = false;
      self.companion = false;
      self.handicapped = false;
      self.recommended = false;
      self.reserved = false;
    }
  };
});

/**
 * Seat Model
 * A model of what a piece of seat data should look like
 *
 * @typedef VenueSeat
 * @property {String} Key identifier for the seat
 * @property {import('../SeatMetaInfo').SeatMetaInfo} [meta]
 * @property {String} [photo] the photo for a seat
 * @property {String} [color] the color of a seat
 */
var Seat = types.model('Seat', {
  Key: types.identifier,
  meta: SeatMetaInfo,
  photo: types.maybe(types.string),
  Color: types.maybe(types.string)
}).preProcessSnapshot(function (snapshot) {
  return _objectSpread2(_objectSpread2({}, snapshot), {}, {
    Key: snapshot.seatKey || snapshot.Key,
    photo: (snapshot.photo || {}).photoUrl || snapshot.photo,
    meta: _objectSpread2({}, snapshot.meta || {})
  });
}).views(function (self) {
  return {
    get section() {
      return self.Key.split('_')[0];
    },
    get row() {
      return self.Key.split('_')[1];
    },
    get seat() {
      return self.Key.split('_')[2];
    }
  };
}).actions(function (self) {
  return {
    init: function init(_ref) {
      var meta = _ref.meta,
        color = _ref.color;
      this.updateMeta(meta);
      this.setColor(color);
    },
    updateMeta: function updateMeta(meta) {
      self.meta = _objectSpread2(_objectSpread2({}, self.meta), meta);
    },
    /**
     * Resets the meta information to its default state
     */
    resetMeta: function resetMeta() {
      self.meta.reset();
    },
    setColor: function setColor(color) {
      self.Color = color;
    }
  };
});

/**
 * SectionMetaInfo Model
 * Models what meta information should look like for a section in a venue
 * @typedef SectionMetaInfo information about the venue that aids in filtering
 * @property {Boolean} [assignedSeating=true] whether or not this has assigned seats.  This is assumed true by
 * @property {Boolean} [available=false] whether or not this is available
 * @property {Boolean} [companion=false] whether or not this contains companion seats
 * @property {Boolean} [handicapped=false] whether or not this contains handicapped seats
 * @property {Boolean} [locked=false] whether or not this is locked or contains locked seats
 * @property {Boolean} [recommended=false] whether or not this is recommended to the user
 * @property {Boolean} [reserved=false] whether or not this is reserved or contains reserved seats
 * @property {Boolean} [onSale=true] whether or not this section is on sale
 * @property {Boolean} [soldOut=true] whether or not this section was sold out
 */

var SectionMetaInfo = types.compose('SectionMetaInfo', SeatMetaInfo, types.model({
  soldOut: types.optional(types["boolean"], false),
  onSale: types.optional(types["boolean"], true),
  assignedSeating: types.optional(types["boolean"], true)
}).actions(function (self) {
  return {
    /**
     * Resets to defaults
     */
    reset: function reset() {
      self.assignedSeating = true;
      self.available = false;
      self.companion = false;
      self.handicapped = false;
      self.recommended = false;
      self.reserved = false;
    }
  };
}));

var PriceRange$1 = types.model('PriceRange', {
  low: types.optional(types.number, 0),
  high: types.optional(types.number, 0)
});

/**
 * @model
 * @typedef VenueSection A section in a venue
 * @property {String} Key identifier for the section
 * @property {Seat[]} [seats = []] a collection of seats
 * @property {import('../SectionMetaInfo').SectionMetaInfo} [meta] meta information about the section
 * @property {String} [Color] the Color of the section
 * @property {Number} [remainingSeats] the number of remaining seats in a section
 * @property {Object} [priceRange] an object containing the lowest and highest price in the section
 * @property {Number} [priceRange.low = 0] the lowest price in the section
 * @property {Number} [priceRange.high = 0] the highest price in the section
 */

var Section = types.model('Section', {
  Key: types.identifier,
  seats: types.array(Seat),
  meta: SectionMetaInfo,
  Color: types.maybe(types.string),
  remainingSeats: types.maybe(types.number),
  priceRange: PriceRange$1
}).preProcessSnapshot(function (snapshot) {
  return _objectSpread2(_objectSpread2({}, snapshot), {}, {
    Key: snapshot.sectionKey || snapshot.Key,
    priceRange: snapshot.priceRange || {},
    meta: _objectSpread2({}, snapshot.meta || {})
  });
}).views(function (self) {
  return {
    get handicappedSeats() {
      return self.seats.filter(function (seat) {
        return seat.meta.handicapped;
      });
    },
    get recommendedSeats() {
      return self.seats.filter(function (seat) {
        return seat.meta.recommended;
      });
    },
    get reservedSeats() {
      return self.seats.filter(function (seat) {
        return seat.meta.reserved;
      });
    },
    get lockedSeats() {
      return self.seats.filter(function (seat) {
        return seat.meta.locked;
      });
    },
    findSeat: function findSeat(toFind) {
      return self.seats.find(function (_ref) {
        var Key = _ref.Key;
        return Key === toFind;
      });
    }
  };
}).actions(function (self) {
  return {
    /**
     * Initializes the section model after it has already been created
     * This will reset the meta data before updating with the new meta
     * @param {Object} section normalized data
     * @param {VenueSeatCollection | *[]} [section.seats] a collection of seats
     * @param {import('../SectionMetaInfo').SectionMetaInfo} [section.meta = {}] meta information about the section
     */
    init: function init(_ref2) {
      var seats = _ref2.seats,
        meta = _ref2.meta;
      this.initSeats(seats);
      this.resetMeta();
      this.updateMeta(meta);
    },
    initSeats: function initSeats(seats) {
      self.seats.replace(seats);
    },
    /**
     *
     * @param {import('../Seat').VenueSeat[]} seats an array of VenueSeats
     */
    addSeats: function addSeats(seats) {
      self.seats.concat(seats);
    },
    /**
     * @param {Boolean} assignedSeating whether or not this section contains reserved seating
     */
    setSeated: function setSeated(assignedSeating) {
      self.meta.assignedSeating = assignedSeating;
    },
    /**
     * Updates the meta information for a section
     * @param {import('../SectionMetaInfo').SectionMetaInfo} [meta = {}]
     */
    updateMeta: function updateMeta() {
      var meta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      self.meta = _objectSpread2(_objectSpread2({}, self.meta), meta);
    },
    /**
     * Updates the price range model
     * @param {Object} [priceRange = {}]
     * @param {Number} [priceRange.low]
     * @param {Number} [priceRange.high]
     */
    updatePriceRange: function updatePriceRange() {
      var priceRange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      self.priceRange = _objectSpread2(_objectSpread2({}, self.priceRange), priceRange);
    },
    /**
     * Resets the meta information to its default state
     */
    resetMeta: function resetMeta() {
      self.meta.reset();
    }
  };
});

/**
 * Venue Model
 * Models the data for a venue
 * @model
 * @typedef VenueModel
 * @property {String} name the name of the venue
 * @property {VenueSectionCollection} sections a Collection of Sections
 */
var Venue = types.model('Venue', {
  // your properties here
  name: types.maybe(types.string),
  sections: types.array(Section)
}).views(function (self) {
  return {
    findSection: function findSection(toFind) {
      return self.sections.find(function (_ref) {
        var Key = _ref.Key;
        return Key === toFind;
      });
    }
  };
}).actions(function (self) {
  return {
    init: function init(_ref2) {
      var _ref2$name = _ref2.name,
        name = _ref2$name === void 0 ? self.name : _ref2$name,
        sections = _ref2.sections;
      self.name = name;
      self.sections.replace(sections);
    },
    deleteSection: function deleteSection(section) {
      self.sections.remove(section);
    }
  };
});

/**
 * SeatSelection Model
 * Manages the state of seat selection
 */
var SeatSelection = types.model('SeatSelection', {
  venue: Venue,
  focusedSection: types.maybe(types.reference(Section)),
  selections: types.map(types.map(types.reference(Seat))),
  recommendedSelections: types.map(types.map(types.reference(Seat)))
}).preProcessSnapshot(function () {
  var snapshot = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread2(_objectSpread2({}, snapshot), {}, {
    selections: snapshot.selections || {}
  });
}).views(function (self) {
  return {
    parseSeatKey: function parseSeatKey(seatKey) {
      var _seatKey$split = seatKey.split('_'),
        _seatKey$split2 = _slicedToArray(_seatKey$split, 3),
        section = _seatKey$split2[0],
        row = _seatKey$split2[1],
        seat = _seatKey$split2[2];
      return {
        section: section,
        row: row,
        seat: seat
      };
    },
    findSeat: function findSeat(key) {
      var _self$parseSeatKey = self.parseSeatKey(key),
        section = _self$parseSeatKey.section;
      return self.venue.findSection(section).findSeat(key);
    },
    sectionIsSelected: function sectionIsSelected(sectionKey) {
      return self.selections.has(sectionKey);
    }
  };
}).actions(function (self) {
  return {
    /**
     * Initialize a seat selection from data or  from scratch
     * @param {Object} seatSelection normalized data
     * @param {import('../Venue').VenueModel} [seatSelection.venue] a collection of seats
     * @param {String} [seatSelection.focusedSection] a key that is a reference to a Section
     * @param {Object} [seatSelection.selections] a map of Section and seat keys
     */
    init: function init(_ref) {
      var venue = _ref.venue,
        focusedSection = _ref.focusedSection,
        selections = _ref.selections;
      self.setVenue(venue);
      self.focusSection(focusedSection);
      self.setSelections(selections);
    },
    setVenue: function setVenue() {
      var venue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      self.venue = venue;
    },
    focusSection: function focusSection(section) {
      self.focusedSection = section;
    },
    setSelections: function setSelections(selections) {
      self.clearSelections();
      self.updateSelections(selections);
    },
    clearSelections: function clearSelections() {
      self.selections.clear();
    },
    updateSelections: function updateSelections(selections) {
      self.selections.merge(selections);
    },
    /**
     * @todo handle duplicate sections
     * @param {import('../Section').VenueSection[]} sections
     */
    addSections: function addSections(sections) {
      self.venue.sections.concat(sections);
    },
    /**
     * Adds seats to a particular section.  If the section does not exist, it will create a new one
     * @param {String} sectionKey the key of the Section to find
     * @param {import('../Seat').VenueSeat[]} seats an array of VenueSeats to add to the section
     */
    addSeats: function addSeats(sectionKey, seats) {
      var section = self.venue.findSection(sectionKey);
      if (!section) {
        self.addSections([{
          key: sectionKey,
          seats: seats
        }]);
      } else {
        section.addSeats(seats);
      }
    },
    /**
     * @callback SeatSelectionValidator decides whether changes to a seat should be accepted before they are applied
     * @param {import('../SeatMetaInfo').SeatMetaInfo} seatMeta the meta info to decide whether or not it should be selected
     * @returns {Boolean} returns true if the seat should be selected, otherwise return false
     *
     * @callback SeatSelectionHandler allows the developer to react to the seat being selected
     * @param {import('../Seat').VenueSeat} seat the seat that was just selected
     *
     * @param {String} key the key of the seat to be selected
     * @param {SeatSelectionValidator} shouldAcceptSelectedSeat
     * @param {SeatSelectionHandler} [onSeatSelected]
     */
    selectSeat: function selectSeat(key) {
      var shouldAcceptSelectedSeat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getEnv(self).shouldAcceptSelectedSeat;
      var onSeatSelected = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : getEnv(self).onSeatSelected;
      try {
        if (typeof shouldAcceptSelectedSeat !== 'function') {
          throw Error("Please provide the 'shouldAcceptSelectedSeat'\nYou provided the value ".concat(shouldAcceptSelectedSeat));
        }
        var seat = self.findSeat(key);
        var _self$parseSeatKey2 = self.parseSeatKey(key),
          section = _self$parseSeatKey2.section;
        if (shouldAcceptSelectedSeat(seat.meta)) {
          self.selections.merge(_defineProperty({}, section, _defineProperty({}, key, key)));
          if (typeof onSeatSelected === 'function') {
            onSeatSelected(seat);
          }
        }
      } catch (e) {
        console.error(e);
      }
    },
    deselectSeat: function deselectSeat(key) {
      var _self$parseSeatKey3 = self.parseSeatKey(key),
        section = _self$parseSeatKey3.section;
      var sectionSelections = self.selections.get(section);
      sectionSelections["delete"](key);

      // clean up
      // @note sections that do not have assigned seating should still be selectable.  This clean up operation is only intended to be used with seats in a section
      if (sectionSelections.size === 0) {
        self.selections["delete"](section);
      }
    }
  };
});

/**
 * PublishingOptions Model
 * Represents publishing options as specified by the ticket socket api
 */
var PublishingOptions = types.model('PublishingOptions', {
  HideFromList: types["boolean"],
  OnSale: types["boolean"],
  IsPublished: types["boolean"]
}).preProcessSnapshot(function () {
  var snapshot = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _snapshot$HideFromLis = snapshot.HideFromList,
    HideFromList = _snapshot$HideFromLis === void 0 ? false : _snapshot$HideFromLis,
    _snapshot$OnSale = snapshot.OnSale,
    OnSale = _snapshot$OnSale === void 0 ? false : _snapshot$OnSale,
    _snapshot$IsPublished = snapshot.IsPublished,
    IsPublished = _snapshot$IsPublished === void 0 ? false : _snapshot$IsPublished;
  return {
    HideFromList: HideFromList,
    OnSale: OnSale,
    IsPublished: IsPublished
  };
});

/**
 * Photo Model
 * Represents a photo as specified by the ticket socket api
 */
var Photo = types.model('Photo', {
  ThumbUrl: types.maybe(types.string),
  PhotoUrl: types.maybe(types.string),
  PhotoId: types.maybe(types.string)
}).preProcessSnapshot(function () {
  var snapshot = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var ThumbUrl = snapshot.ThumbUrl,
    PhotoUrl = snapshot.PhotoUrl,
    PhotoId = snapshot.PhotoId;
  return {
    PhotoId: PhotoId,
    PhotoUrl: PhotoUrl,
    ThumbUrl: ThumbUrl || PhotoUrl
  };
}).views(function (self) {
  return {
    get id() {
      return self.PhotoId;
    }
  };
});

/**
 * IsoDate Model
 * Parses iso dates for human readability
 */
var IsoDate = types.model('IsoDate', {
  raw: types.refinement(types.string, function (str) {
    return isValid(parseISO(str));
  })
}).preProcessSnapshot(function () {
  var snapshot = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var corrected = snapshot;
  if (typeof snapshot === 'string') {
    corrected = {
      raw: snapshot
    };
  }
  return corrected;
}).actions(function (self) {
  return {
    setDate: function setDate(date) {
      self.raw = date;
    }
  };
}).views(function (self) {
  return {
    get asDate() {
      return parseISO(self.raw);
    },
    localeDateString: function localeDateString() {
      var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      };
      return this.asDate.toLocaleDateString(locale, options);
    },
    lightFormat: function lightFormat() {
      var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'M/d/yyyy';
      return _lightFormat(this.asDate, format);
    }
  };
});

/**
 * DateRange Model
 * Represents a date range as specified by the ticket socket api
 * @todo create a date format with helper methods
 */
var DateRange = types.model('DateRange', {
  From: IsoDate,
  To: IsoDate
}).preProcessSnapshot(function () {
  var snapshot = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var From = snapshot.From,
    To = snapshot.To;
  var correctedFrom = From;
  var correctedTo = To;
  if (From && typeof From === 'string') {
    correctedFrom = {
      raw: From
    };
  }
  if (To && typeof To === 'string') {
    correctedTo = {
      raw: To
    };
  }
  return _objectSpread2(_objectSpread2({}, snapshot), {}, {
    From: correctedFrom,
    To: correctedTo
  });
}).actions(function (self) {
  return {
    setRange: function setRange(_ref) {
      var _ref$From = _ref.From,
        From = _ref$From === void 0 ? self.From : _ref$From,
        _ref$To = _ref.To,
        To = _ref$To === void 0 ? self.To : _ref$To;
      self.From.setDate(From);
      self.To.setDate(To);
    }
  };
}).views(function (self) {
  return {
    get range() {
      return {
        from: self.From.asDate,
        to: self.To.asDate
      };
    },
    format: function format(_ref2) {
      var _ref2$locale = _ref2.locale,
        locale = _ref2$locale === void 0 ? 'en-US' : _ref2$locale,
        options = _ref2.options;
      var From = self.From.localeDateString({
        locale: locale,
        options: options
      });
      var To = self.To.localeDateString({
        locale: locale,
        options: options
      });
      return From === To ? From : "".concat(From, " - ").concat(To);
    }
  };
});

/**
 * Price Model
 * Helps with the formatting and interaction with currency data
 */
var Price = types.model('Price', {
  value: types.number
}).preProcessSnapshot(function () {
  var snapshot = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    value: (typeof snapshot === 'number' ? snapshot : snapshot.value) || 0
  };
}).views(function (self) {
  return {
    formatLocale: function formatLocale() {
      var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        style: 'currency'
      };
      // if the number can be expressed as 12.00, truncate to 12
      var minimumFractionDigits = self.hasDecimals ? 2 : 0;
      return self.value.toLocaleString(locale, _objectSpread2({
        minimumFractionDigits: minimumFractionDigits,
        style: 'currency'
      }, options));
    },
    get hasDecimals() {
      return self.value % 1 !== 0;
    }
  };
});

/**
 * PriceRange Model
 * Aids in the formatting of 2 price models
 */
var PriceRange = types.model('PriceRange', {
  From: Price,
  To: Price
}).views(function (self) {
  return {
    format: function format(_ref) {
      var _ref$locale = _ref.locale,
        locale = _ref$locale === void 0 ? 'en-US' : _ref$locale,
        options = _ref.options;
      var From = self.From.formatLocale(locale, options);
      var To = self.To.formatLocale(locale, options);
      return From === To ? From : "".concat(From, " - ").concat(To);
    }
  };
});

/**
 * Address Model
 * Represents an address as specified by the ticket socket api
 *
 * @todo figure out what values are needed for international addresses
 */
var Address = types.model('Address', {
  CountryCode: types.maybeNull(types.string),
  PostalCode: types.maybeNull(types.string),
  State: types.maybeNull(types.string),
  City: types.maybeNull(types.string),
  Line1: types.maybeNull(types.string),
  Line2: types.maybeNull(types.string)
}).preProcessSnapshot(function () {
  var snapshot = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _snapshot$CountryCode = snapshot.CountryCode,
    CountryCode = _snapshot$CountryCode === void 0 ? '' : _snapshot$CountryCode,
    _snapshot$PostalCode = snapshot.PostalCode,
    PostalCode = _snapshot$PostalCode === void 0 ? '' : _snapshot$PostalCode,
    _snapshot$State = snapshot.State,
    State = _snapshot$State === void 0 ? '' : _snapshot$State,
    _snapshot$City = snapshot.City,
    City = _snapshot$City === void 0 ? '' : _snapshot$City,
    _snapshot$Line = snapshot.Line1,
    Line1 = _snapshot$Line === void 0 ? '' : _snapshot$Line,
    _snapshot$Line2 = snapshot.Line2,
    Line2 = _snapshot$Line2 === void 0 ? '' : _snapshot$Line2;
  return {
    CountryCode: CountryCode,
    PostalCode: PostalCode,
    State: State,
    City: City,
    Line1: Line1,
    Line2: Line2
  };
}).actions(function (self) {
  return {
    updateAddress: function updateAddress(_ref) {
      var _ref$CountryCode = _ref.CountryCode,
        CountryCode = _ref$CountryCode === void 0 ? self.CountryCode : _ref$CountryCode,
        _ref$PostalCode = _ref.PostalCode,
        PostalCode = _ref$PostalCode === void 0 ? self.PostalCode : _ref$PostalCode,
        _ref$State = _ref.State,
        State = _ref$State === void 0 ? self.State : _ref$State,
        _ref$City = _ref.City,
        City = _ref$City === void 0 ? self.City : _ref$City,
        _ref$Line = _ref.Line1,
        Line1 = _ref$Line === void 0 ? self.Line1 : _ref$Line,
        _ref$Line2 = _ref.Line2,
        Line2 = _ref$Line2 === void 0 ? self.Line2 : _ref$Line2;
      self.CountryCode = CountryCode;
      self.PostalCode = PostalCode;
      self.State = State;
      self.City = City;
      self.Line1 = Line1;
      self.Line2 = Line2;
    }
  };
});

/**
 * VenueInfo Model
 * Represents information for a venue as specified by the ticket socket api
 */
var VenueInfo = types.model('VenueInfo', {
  Address: types.maybe(types.string),
  Description: types.maybe(types.string),
  Seated: types["boolean"],
  SeatingChart: types.maybe(types.string),
  ShowOnMap: types["boolean"]
}).preProcessSnapshot(function () {
  var snapshot = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread2(_objectSpread2({}, snapshot), {}, {
    Address: snapshot.Address || '',
    Seated: snapshot.Seated || false,
    ShowOnMap: snapshot.ShowOnMap || false
  });
}).views(function (self) {
  return {
    get baseVenueUrl() {
      if (!self.SeatingChart) return '';
      var fragments = self.SeatingChart.split('/');
      return fragments.slice(0, fragments.length - 1).join('/');
    }
  };
});

/**
 * EventDescription Model
 * Short and long descriptions for an event usually dynamically loaded from a url
 * @todo might want to give this model a loading volatile state
 */
var EventDescription = types.model('EventDescription', {
  ShortDescription: types.maybeNull(types.string),
  LongDescription: types.maybeNull(types.string)
}).preProcessSnapshot(function () {
  var snapshot = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread2({}, snapshot);
}).actions(function (self) {
  return {
    setDescriptions: function setDescriptions(_ref) {
      var _ref$ShortDescription = _ref.ShortDescription,
        ShortDescription = _ref$ShortDescription === void 0 ? null : _ref$ShortDescription,
        _ref$LongDescription = _ref.LongDescription,
        LongDescription = _ref$LongDescription === void 0 ? null : _ref$LongDescription;
      self.ShortDescription = ShortDescription;
      self.LongDescription = LongDescription;
    }
  };
});

/**
 * Event Model
 * Represents an event retrieved from the ticket socket api
 */
var Event = types.model('Event', {
  // your properties here
  PublishingOptions: PublishingOptions,
  Id: types.identifier,
  HighPrice: Price,
  LowPrice: Price,
  PriceRange: PriceRange,
  Venue: VenueInfo,
  When: DateRange,
  Sales: DateRange,
  Title: types.string,
  // optional and nullable properties
  HideICS: types.maybe(types["boolean"]),
  ShowCheckoutModal: types.maybe(types["boolean"]),
  HideSectionPhotos: types.maybe(types["boolean"]),
  IsRecurringEvent: types.maybe(types["boolean"]),
  IsSeated: types.maybe(types["boolean"]),
  DisplayOrder: types.maybe(types.number),
  SiteId: types.maybe(types.string),
  BaseUrl: types.maybe(types.string),
  UrlSlug: types.maybeNull(types.string),
  EmbeddedVideo: types.maybeNull(types.string),
  ListPhoto: types.maybeNull(Photo),
  DescriptionUrl: types.maybeNull(types.string),
  Description: types.maybeNull(EventDescription),
  Photos: types.maybeNull(types.array(Photo))
}).preProcessSnapshot(function () {
  var snapshot = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // handle inconsistencies between returns.
  /** @todo unify this when api is consistent */
  var ListPhoto = snapshot.ListPhoto,
    IsRecurring = snapshot.IsRecurring,
    IsRecurringEvent = snapshot.IsRecurringEvent,
    HighPrice = snapshot.HighPrice,
    LowPrice = snapshot.LowPrice,
    Photo = snapshot.Photo;
  return _objectSpread2(_objectSpread2({}, snapshot), {}, {
    ListPhoto: ListPhoto || Photo || {},
    IsRecurringEvent: IsRecurringEvent !== undefined ? IsRecurringEvent : IsRecurring,
    PriceRange: {
      From: LowPrice,
      To: HighPrice
    }
  });
});

/**
 * MinimalId Model
 *
 */
var MinimalId = types.model('MinimalId', {
  Id: types.string,
  Name: types.string
});

/**
 * Fee Model
 * Represents a fee as specified by the ticket socket api
 */
var Fee = types.model('Fee', {
  Amount: types.number,
  ExcludeFeeFromTaxCalculation: types["boolean"],
  IsTax: types["boolean"],
  Name: types.string
});

/**
 * PromoCode Model
 * Represents a promo code as specified by the ticket socket api
 */
var PromoCode = types.model('PromoCode', {
  Amount: Price,
  Code: types.string,
  Id: types.maybe(types.string),
  Name: types.maybe(types.string)
});

/**
 * Ticket Model
 * Represents a ticket as specified by the ticket socket api
 * @todo: might want to create 3 types of ticket: BaseTicket, TicketSelection, CartTicket
 */
var Ticket = types.model('Ticket', {
  Id: types.identifier,
  Price: Price,
  OriginalPrice: types.maybe(Price),
  Event: types.maybe(MinimalId),
  Fees: types.maybeNull(types.array(Fee)),
  PromoCodes: types.maybeNull(types.array(types.maybeNull(PromoCode))),
  Seat: types.maybeNull(types.string),
  Status: types.maybe(types.string),
  Tier: types.maybe(MinimalId),
  Type: types.maybe(MinimalId),
  Title: types.maybeNull(types.string),
  Subtitle: types.maybeNull(types.string),
  /** @todo  figure out shape of Category */
  Category: types.maybeNull(types.frozen({})),
  /** @todo  separate this into it's own model */
  Quantity: 0
}).views(function (self) {
  return {
    get parsedSeatKey() {
      if (!self.Seat) return {};
      var _self$Seat$split = self.Seat.split('-'),
        _self$Seat$split2 = _slicedToArray(_self$Seat$split, 3),
        section = _self$Seat$split2[0],
        row = _self$Seat$split2[1],
        seat = _self$Seat$split2[2];
      return {
        section: section,
        row: row,
        seat: seat
      };
    }
  };
}).actions(function (self) {
  return {
    setQuantity: function setQuantity(quantity) {
      self.Quantity = quantity;
    }
  };
});

/**
 * PurchaserInfo Model
 * Represents purchaser info as specified by the ticket socket api
 */
var PurchaserInfo = types.model('PurchaserInfo', {
  EmailAddress: '',
  LastName: '',
  FirstName: ''
}).preProcessSnapshot(function () {
  var snapshot = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    EmailAddress: '',
    LastName: '',
    FirstName: ''
  };
  return _objectSpread2({}, snapshot);
}).actions(function (self) {
  return {
    setEmail: function setEmail(email) {
      return self.EmailAddress = email;
    },
    setFirstName: function setFirstName(first) {
      return self.FirstName = first;
    },
    setLastName: function setLastName(last) {
      return self.LastName = last;
    },
    setPurchaser: function setPurchaser(_ref) {
      var EmailAddress = _ref.EmailAddress,
        FirstName = _ref.FirstName,
        LastName = _ref.LastName;
      self.setEmail(EmailAddress);
      self.setFirstName(FirstName);
      self.setLastName(LastName);
    },
    clear: function clear() {
      self.EmailAddress = '';
      self.LastName = '';
      self.FirstName = '';
      return true;
    }
  };
}).views(function (self) {
  return {
    get fullname() {
      return "".concat(self.FirstName, " ").concat(self.LastName);
    },
    get fields() {
      return getSnapshot(self);
    }
  };
});

/**
 * Cart Model
 * Represents a cart as specified by the TicketSocket API
 * @todo anotate types for Ticket, Fee, and Purchaser Info
 * @typedef {Object} CartType a cart shaped defined by the TicketSocket API
 * @property {Number} [TicketTotal] sum of the costs of tickets
 * @property {Number} [TotalFeesAndTaxes] sum of all fees and taxes
 * @property {Number} [GrandTotal] sum of all tickets, fees, and taxes
 * @property {Number} [ValidUntil] timestamp in ms of how long the Cart is valid
 * @property {*[]} [Tickets = []] Tickets that have been added to the cart
 * @property {*[]} [Fees = []] Array of fees associated with the current order
 * @property {*[]} [PromoCodes = []] Array of promo codes applied to the cart
 * @property {Object} [Purchaser = {}] An object containing Purchaser information
 * @property {String} [Id] A unique identifier for the cart
 */
var Cart = types.model('Cart', {
  TicketTotal: Price,
  TotalFeesAndTaxes: Price,
  GrandTotal: Price,
  ValidUntil: types.number,
  Number: types.maybeNull(types.string),
  PromoCodes: types.maybeNull(types.array(types.maybeNull(PromoCode))),
  Tickets: createCollection('Tickets', Ticket),
  Fees: createCollection('Fees', Fee),
  Purchaser: PurchaserInfo,
  Id: types.string
}).preProcessSnapshot(function () {
  var snapshot = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _snapshot$TicketTotal = snapshot.TicketTotal,
    TicketTotal = _snapshot$TicketTotal === void 0 ? 0 : _snapshot$TicketTotal,
    _snapshot$TotalFeesAn = snapshot.TotalFeesAndTaxes,
    TotalFeesAndTaxes = _snapshot$TotalFeesAn === void 0 ? 0 : _snapshot$TotalFeesAn,
    _snapshot$GrandTotal = snapshot.GrandTotal,
    GrandTotal = _snapshot$GrandTotal === void 0 ? 0 : _snapshot$GrandTotal,
    _snapshot$ValidUntil = snapshot.ValidUntil,
    ValidUntil = _snapshot$ValidUntil === void 0 ? 0 : _snapshot$ValidUntil,
    _snapshot$Tickets = snapshot.Tickets,
    Tickets = _snapshot$Tickets === void 0 ? [] : _snapshot$Tickets,
    _snapshot$Fees = snapshot.Fees,
    Fees = _snapshot$Fees === void 0 ? [] : _snapshot$Fees,
    _snapshot$Purchaser = snapshot.Purchaser,
    Purchaser = _snapshot$Purchaser === void 0 ? {} : _snapshot$Purchaser,
    _snapshot$Id = snapshot.Id,
    Id = _snapshot$Id === void 0 ? '' : _snapshot$Id;
  return _objectSpread2(_objectSpread2({}, snapshot), {}, {
    TicketTotal: TicketTotal,
    TotalFeesAndTaxes: TotalFeesAndTaxes,
    GrandTotal: GrandTotal,
    ValidUntil: ValidUntil,
    Tickets: Tickets,
    Fees: Fees,
    Purchaser: Purchaser,
    Id: Id
  });
}).actions(function (self) {
  return {
    /**
     * Initializes the cart from an API or storage
     * @param {CartType} data
     * @returns on success, the data used to hydrate the store.  on error, will just console error
     */
    hydrate: function hydrate(data) {
      try {
        Object.keys(data).forEach(function (prop) {
          return self[prop] = data[prop];
        });
        return data;
      } catch (e) {
        console.error(e);
      }
    },
    /**
     * Clears the cart and resets to initial values
     */
    clear: function clear() {
      self.TicketTotal = 0;
      self.TotalFeesAndTaxes = 0;
      self.GrandTotal = 0;
      self.ValidUntil = 0;
      self.Number = null;
      self.Tickets.clearItems();
      self.Fees.clearItems();
      self.Purchaser.clear();
      self.Id = '';
    }
  };
});

/**
 * CacheControl Model
 * A cache model built on top of lru the cache is volatile and will not be persisted across page refreshes.
 * Mainly used to prevent subsequent api requests from being called again within a certain time period.
 * To persist data, use localstorage instead of the cache.
 *
 * For instructions on how to use LRU, visit https://github.com/isaacs/node-lru-cache#readme
 */
var CacheControl = types.model('CacheControl', {
  /** The number of entries allowed in the cache */
  max: 500,
  /** By default, a cache entry will expire in 10 minutes */
  maxAge: 1000 * 60 * 10
}).preProcessSnapshot(function () {
  var snapshot = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return snapshot;
})["volatile"](function (self) {
  return {
    lru: new LRU({
      max: self.max,
      maxAge: self.maxAge
    })
  };
})
/** exposing LRU methods here so we can track updates to the cache via snapshots since the cache is volatile */.actions(function (self) {
  return {
    set: function set() {
      var _self$lru;
      (_self$lru = self.lru).set.apply(_self$lru, arguments);
    },
    del: function del(key) {
      self.lru.del(key);
    },
    reset: function reset() {
      self.lru.reset();
    },
    load: function load(entries) {
      self.lru.load(entries);
    },
    prune: function prune() {
      self.lru.prune();
    }
  };
}).views(function (self) {
  return {
    get: function get(key) {
      return self.lru.get(key);
    },
    has: function has(key) {
      return self.lru.has(key);
    },
    peek: function peek(key) {
      return self.lru.peek(key);
    },
    dump: function dump() {
      return self.lru.dump();
    },
    get values() {
      return self.lru.values();
    },
    get length() {
      return self.lru.length;
    },
    get itemCount() {
      return self.lru.itemCount;
    }
  };
});

/**
 * AsyncApi Model
 * A generic model for async functionality using api resources
 *
 * @callback APIResource
 * @param { Object } args arguments passed to an API url
 * @param { Object } [params = {}] query parameters
 * @param { Object } [headers = {}] optional headers to pass to the call
 * @returns an Axios instance
 */
var AsyncApi = types.model('AsyncApi', {
  cache: CacheControl
})["volatile"](function (self) {
  return {
    loading: false,
    apiError: false,
    returnData: undefined
  };
}).actions(function (self) {
  return {
    /**
     * factory function that creates an API flow
     * @param { APIResource } apiResource
     */
    createAsyncApi: function createAsyncApi(apiResource) {
      var maxAge = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : self.cache.maxAge;
      return flow$1(function (_ref) {
        var _ref$args = _ref.args,
          args = _ref$args === void 0 ? {} : _ref$args,
          _ref$params = _ref.params,
          params = _ref$params === void 0 ? {} : _ref$params,
          _ref$headers = _ref.headers,
          headers = _ref$headers === void 0 ? {} : _ref$headers;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          var _options$transformRes, transformResponse, _options$transformErr, transformErrorResponse, _options$onSuccess, onSuccess, _options$onFinished, onFinished, _options$maxAge, maxAgeOpts, key, response, res;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                /**
                 * Some defaults
                 */
                _options$transformRes = options.transformResponse, transformResponse = _options$transformRes === void 0 ? function (res) {
                  return res;
                } : _options$transformRes, _options$transformErr = options.transformErrorResponse, transformErrorResponse = _options$transformErr === void 0 ? function (err) {
                  return err;
                } : _options$transformErr, _options$onSuccess = options.onSuccess, onSuccess = _options$onSuccess === void 0 ? function (res) {
                  return res;
                } : _options$onSuccess, options.onError, _options$onFinished = options.onFinished, onFinished = _options$onFinished === void 0 ? function (res) {
                  return res;
                } : _options$onFinished, _options$maxAge = options.maxAge, maxAgeOpts = _options$maxAge === void 0 ? maxAge : _options$maxAge;
                self.loading = true;
                self.apiError = false;

                /**
                 * Main Flow (success) --
                 *
                 * Step 1:  		Get a cache key based on the function being called and the arguments passed to it
                 * Step 2:  		Attempt to get a value from the cache using that key
                 * Step 3a:			If there is a value in the cache, DO NOT make the API call
                 * Step 3b.1:   If the value in the cache is undefined, make the API call
                 * Step 3b.2:		If the call is successful, set the value in the cache using the key from step 1
                 * Step 3b.3:		Call transformResponse on the response data
                 * Step 4:			Call onSuccess with the data
                 * Step 5:			Call onFinished with the data
                 * Step 6:			Clean up local state
                 *
                 * Main Flow (failure) --
                 * If any errors occure between step 1 and 4, the error will be caught and the following will occur
                 * 1)  Call transformErrorResponse
                 * 2)  Set returnData to the transformed error
                 * 3)  Finally block will return the error back to the caller
                 */
                _context.prev = 3;
                // create a key for the cache based off the resource being called and the args, params, and headers
                key = "".concat(apiResource.name, ".").concat(md5(JSON.stringify(args)), ".").concat(md5(JSON.stringify(params)), ".").concat(md5(JSON.stringify(headers))); // if this api call was made with the same arguments, returnData should contain the value
                self.returnData = self.cache.get(key);
                // only call the api if it hasn't been cached yet
                if (!(self.returnData === undefined)) {
                  _context.next = 12;
                  break;
                }
                _context.next = 9;
                return apiResource(args, params, headers);
              case 9:
                response = _context.sent;
                self.returnData = transformResponse(response);
                self.cache.set(key, self.returnData, maxAgeOpts);
              case 12:
                if (!isPromise(onSuccess)) {
                  _context.next = 17;
                  break;
                }
                _context.next = 15;
                return onSuccess(self.returnData);
              case 15:
                _context.next = 18;
                break;
              case 17:
                onSuccess(self.returnData);
              case 18:
                return _context.abrupt("return", self.returnData);
              case 21:
                _context.prev = 21;
                _context.t0 = _context["catch"](3);
                self.returnData = transformErrorResponse(_context.t0.response);
                self.apiError = true;
                // if (isPromise(onSuccess)) {
                // 	yield onError(self.returnData);
                // } else {
                // 	onError(self.returnData);
                // }

                // throw new Error(error);
              case 25:
                _context.prev = 25;
                res = self.returnData;
                onFinished(self.returnData);
                self.loading = false;
                self.returnData = undefined;
                return _context.abrupt("return", res);
              case 32:
              case "end":
                return _context.stop();
            }
          }, _callee, null, [[3, 21, 25, 32]]);
        })();
      });
    },
    reset: function reset() {
      self.loading = false;
      self.apiError = false;
      self.returnData = undefined;
      self.cache.reset();
    }
  };
});
var isPromise = function isPromise(toTest) {
  return toTest.then && typeof toTest.then === 'function';
};

/**
 * Input Model
 * Standard data interface for an input.  Should be used with a Form model instead of
 * by itself for the best developer experience
 */
var Input = types.model('Input', {
  name: types.string,
  /** @todo add more enumerations */
  type: types.optional(types.enumeration(['text', 'email', 'password']), 'text'),
  allowSubmit: false,
  required: false,
  defaultValue: '',
  value: '',
  valid: true,
  error: types.maybeNull(types.string)
}).preProcessSnapshot(function (snapshot) {
  return _objectSpread2(_objectSpread2({}, snapshot), {}, {
    value: snapshot.defaultValue || snapshot.value
  });
})["volatile"](function (self) {
  return {
    validator: function validator() {
      return !(self.required && self.value === '');
    }
  };
}).actions(function (self) {
  return {
    updateValue: function updateValue(value) {
      return self.value = value;
    },
    /**
     * @callback InputValidator
     * @param {String} [value]  the value of the input to be validated
     * @param {Boolean} [required] whether or not this input was configured as required
     * @returns {Boolean} whether or not the input is valid
     *
     * @param {InputValidator} validator
     * @returns {Boolean} whether or not the input is valid
     */
    validate: function validate() {
      var validator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : self.validator;
      if (validator(self.value, self.required)) {
        return self.valid = true;
      }
      return self.valid = false;
    },
    setRequired: function setRequired() {
      var required = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      return self.required = required;
    },
    setError: function setError(error) {
      return self.error = error;
    },
    clear: function clear() {
      self.value = '';
      self.error = null;
    },
    reset: function reset() {
      self.value = self.defaultValue;
      self.error = null;
    },
    /*
     * @param {InputValidator} validator
     * @returns {Boolean} whether or not the input is valid
     */
    setValidator: function setValidator(validator) {
      self.validator = validator;
    }
  };
});

/**
 * Form Model
 * Standard interface for handling a form with user inputs
 */
var Form = types.model('Form', {
  name: types.string,
  inputs: types.map(Input)
})["volatile"](function (self) {
  return {
    validators: values(self.inputs).reduce(function (validators, input) {
      return _objectSpread2(_objectSpread2({}, validators), {}, _defineProperty({}, input.name, input.validator));
    }, {})
  };
}).views(function (self) {
  return {
    get values() {
      return values(self.inputs).reduce(function (vals, input) {
        return _objectSpread2(_objectSpread2({}, vals), {}, _defineProperty({}, input.name, input.value));
      }, {});
    },
    get: function get(name) {
      return self.inputs.get(name);
    }
  };
}).actions(function (self) {
  return {
    getValidations: function getValidations() {
      var validators = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : self.validators;
      return values(self.inputs).reduce(function (validations, input) {
        return _objectSpread2(_objectSpread2({}, validations), {}, _defineProperty({}, input.name, input.validate(validators[input.name])));
      }, {});
    },
    setValidator: function setValidator(name, validator) {
      try {
        if (!self.inputs.has(name)) {
          throw "setValidator error: No input found with name '".concat(name, "'");
        }
        if (typeof validator !== 'function') {
          throw 'setValidator error: validator must be a function';
        }
        self.validators[name] = validator;
      } catch (e) {
        console.error(e);
      }
    },
    reset: function reset() {
      values(self.inputs).forEach(function (input) {
        return input.reset();
      });
    },
    clear: function clear() {
      values(self.inputs).forEach(function (input) {
        return input.clear();
      });
    }
  };
});

/**
 * Collection2 Model
 * V2 of collection model
 *
 * dynamically creates a collection of any supported MST type
 *
 * @todo remove the 2 once Collection is fully deprecated
 */

/**
 * @param {*} type an MST type
 */
var makeCollection2 = function makeCollection2(type) {
  return types.model({
    record: types.map(type)
  }).preProcessSnapshot(function () {
    var snapshot = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return _objectSpread2({}, snapshot);
  }).views(function (self) {
    return {
      get mappings() {
        return self.record.toJSON();
      },
      get list() {
        return Object.keys(self.mappings).map(function (key) {
          return self.mappings[key];
        });
      },
      get size() {
        return self.record.size;
      },
      values: function values() {
        return self.record.values();
      },
      has: function has(key) {
        return self.record.has(key);
      }
    };
  }).actions(function (self) {
    return {
      /**
       * @callback RecorderCb
       * @param {*} item the entity to be recorded
       * @param {function} set a function to set the item
       */
      /**
       * adds items sequentially.  Use this for more fine grained control when adding items to the record
       * @param {*[]} items an array of items to record
       * @param {RecorderCb} recorder
       */
      save: function save(items, recorder) {
        items.forEach(function (item) {
          return recorder(item, self.add);
        });
      },
      /**
       * Merges a collection object with the record
       * @param {Object} items the object to merge with the record
       */
      merge: function merge(items) {
        self.record.merge(items);
      },
      /**
       * Completely overwrites current entries with the passed items
       * @param {Object} items the object to replace the record
       */
      replace: function replace(items) {
        self.record.replace(items);
      },
      add: function add(key, item) {
        self.record.set(key, item);
      },
      "delete": function _delete(key) {
        self.record["delete"](key);
      },
      clear: function clear() {
        self.record.clear();
      },
      get: function get(key) {
        return self.record.get(key);
      }
    };
  });
};

/**
 * @note
 * this might look silly... and it kind of is.  But the reason why this is being done
 * is because any model with an identifier must be unique in the ENTIRE tree.
 * Making a Ticket-like Model allows us to interact with the data as if it were an actual ticket
 * but also allows us to cache it in a Collection later on without any issues.
 */
var TicketCopy = types.compose(types.model({}), Ticket).named('TicketCopy');
/**
 * Seat2 Model
 * V2 of seat model
 */
var Seat2 = types.model('Seat2', {
  Accessible: false,
  Available: false,
  Tiers: types.array(TicketCopy),
  Key: types.string,
  Number: types.string
}).preProcessSnapshot(function () {
  var snapshot = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread2(_objectSpread2({}, snapshot), {}, {
    // re-mapping these temporarily, because the response isn't completely what is expected
    Key: snapshot.Seat,
    Number: snapshot.Key
  });
});

var SeatCollection = makeCollection2(Seat2).named('Seat');
var mapSeatsToCollection = function mapSeatsToCollection() {
  var seats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var collection = {
    record: seats.reduce(function (map, seat) {
      return _objectSpread2(_objectSpread2({}, map), {}, _defineProperty({}, seat.Seat, seat));
    }, {})
  };
  return collection;
};
/**
 * Row Model
 * Represents a row as defined by the api
 */
var Row = types.model('Row', {
  Number: types.string,
  Seats: SeatCollection
}).preProcessSnapshot(function () {
  var snapshot = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread2(_objectSpread2({}, snapshot), {}, {
    Number: snapshot.Id,
    Seats: Array.isArray(snapshot.Seats) ? mapSeatsToCollection(snapshot.Seats) : snapshot.Seats
  });
}).views(function (self) {
  return {
    get numSeats() {
      return self.Seats.size;
    },
    get availableSeats() {
      var seats = self.Seats.values();
      var available = {};
      while (true) {
        var _seats$next = seats.next(),
          value = _seats$next.value,
          done = _seats$next.done;
        if (done) break;
        if (value.Available) {
          available[value.Key] = value;
        }
      }
      return available;
    },
    getSeat: function getSeat(seatKey) {
      return self.Seats.get(seatKey);
    },
    hasSeat: function hasSeat(seatKey) {
      return self.Seats.has(seatKey);
    }
  };
}).actions(function (self) {
  return {
    addSeats: function addSeats() {
      var seats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return self.Seats.save(seats, function (seat, add) {
        return add(seat.Seat, seat);
      });
    },
    addSeat: function addSeat(seat) {
      return self.Seats.add(seat.Seat, seat);
    },
    clearSeats: function clearSeats() {
      return self.Seats.clear();
    }
  };
});

var RowCollection = makeCollection2(Row).named('RowCollection');
var mapRowsToCollection = function mapRowsToCollection() {
  var rows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var collection = {
    record: rows.reduce(function (map, row) {
      return _objectSpread2(_objectSpread2({}, map), {}, _defineProperty({}, row.Id, row));
    }, {})
  };
  return collection;
};
/**
 * Section2 Model
 * V2 section model
 */
var Section2 = types.model('Section2', {
  assignedSeating: types["boolean"],
  Color: types.maybe(types.string),
  Key: types.string,
  Rows: RowCollection,
  SeatsAvailable: types.maybe(types.number),
  Svg: types.maybe(types.string),
  PriceRange: PriceRange
}).preProcessSnapshot(function () {
  var snapshot = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread2(_objectSpread2({}, snapshot), {}, {
    assignedSeating: snapshot.assignedSeating || !snapshot.GA || false,
    PriceRange: {
      From: snapshot.LowPrice || 0,
      To: snapshot.HighPrice || 0
    },
    Rows: Array.isArray(snapshot.Rows) ? mapRowsToCollection(snapshot.Rows) : undefined
  });
}).views(function (self) {
  return {
    get isSoldOut() {
      return self.SeatsAvailable <= 0;
    },
    get numRows() {
      return self.Rows.size;
    },
    get availableSeats() {
      var available = {};
      var rows = self.Rows.values();
      while (true) {
        var _rows$next = rows.next(),
          done = _rows$next.done,
          value = _rows$next.value;
        if (done) break;
        available = _objectSpread2(_objectSpread2({}, available), value.availableSeats);
      }
      return available;
    },
    getRow: function getRow(rowKey) {
      return self.Rows.get(rowKey);
    },
    getSeat: function getSeat(rowKey, seatKey) {
      return self.hasRow(rowKey) ? self.getRow(rowKey).getSeat(seatKey) : undefined;
    },
    hasRow: function hasRow(rowKey) {
      return self.Rows.has(rowKey);
    }
  };
}).actions(function (self) {
  return {
    setColor: function setColor(color) {
      self.Color = color;
    },
    addRow: function addRow(row) {
      self.Rows.add(row.Key, row);
    },
    addRows: function addRows() {
      var rows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      // note that we are accessing Id here instead of Key like the model says.  This is because of a discrepancy in the API.
      // trying to make it consistent in the meantime when there is bandwith for the API to be updated
      self.Rows.save(rows, function (row, add) {
        return add(row.Id, row);
      });
    },
    clearRows: function clearRows() {
      self.Rows.clear();
    }
  };
});

var SectionCollection = makeCollection2(Section2).named('SectionCollection');

/**
 * VenueOrchestrator Model
 * Orchestrates the state and appearance of seats rows and sections within a venue
 *
 * @note this will replace the SeatSelection model
 */
var VenueOrchestrator = types.model('VenueOrchestrator', {
  info: VenueInfo,
  Sections: SectionCollection,
  selectedSections: types.map(types.string),
  selectedRows: types.map(types.string),
  selectedSeats: types.map(types.string)
})["volatile"](function (self) {
  return {
    // we are keeping a key here instead of having an MST reference because venues maybe destroyed
    // frequently and might end up with null references
    focusedRowKey: undefined,
    focusedSeatKey: undefined,
    focusedSectionKey: undefined
  };
}).views(function (self) {
  return {
    get focusedSeat() {
      return self.getSeat(self.focusedSectionKey, self.focusedRowKey, self.focusedSeatKey);
    },
    get focusedSection() {
      return self.getSection(self.focusedSectionKey);
    },
    get numSections() {
      return self.Sections.size;
    },
    getRow: function getRow(section, row) {
      return self.hasSection(section) ? self.getSection(section).getRow(row) : undefined;
    },
    getSeat: function getSeat(section, row, seat) {
      return self.sectionHasRow(section, row) ? self.getRow(section, row).getSeat(seat) : undefined;
    },
    getSection: function getSection(key) {
      return self.Sections.get(key);
    },
    hasSection: function hasSection(key) {
      return self.Sections.has(key);
    },
    /**
     *
     * @param {*} mapFn
     * @returns {*[]}
     */
    mapSectionsToList: function mapSectionsToList(mapFn) {
      var list = [];
      var sections = self.Sections.values();
      while (true) {
        var _sections$next = sections.next(),
          value = _sections$next.value,
          done = _sections$next.done;
        if (done) break;
        list.push(mapFn(value));
      }
      return list;
    },
    /**
     * the mapping is done by the developer.
     * what this does is that it goes through the entire record, lets the developer decide how
     * each item should be formatted, and reduces it into a finished map
     * @param {*} mapFn
     * @returns {Object}
     */
    mapSectionsToProps: function mapSectionsToProps() {
      var mapFn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (item) {
        return item;
      };
      var reduced = {};
      // values() returns an iterator, which is why we are iterating this way
      // we do this instead of turning it into a regular object in order to
      // preserve the obeservable nature of the object for use during mapping
      var sections = self.Sections.values();
      while (true) {
        var _sections$next2 = sections.next(),
          value = _sections$next2.value,
          done = _sections$next2.done;
        if (done) break;
        reduced[value.Key] = mapFn(value);
      }
      return reduced;
    },
    mapSeatsToProps: function mapSeatsToProps(section) {
      var mapFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (item) {
        return item;
      };
      if (!self.hasSection(section)) return {};
      var reduced = {};
      var rows = self.getSection(section).Rows.values();
      while (true) {
        var _rows$next = rows.next(),
          value = _rows$next.value,
          done = _rows$next.done;
        if (done) break;
        var seats = value.Seats.values();
        while (true) {
          var _seats$next = seats.next(),
            seat = _seats$next.value,
            seatsDone = _seats$next.done;
          if (seatsDone) break;
          reduced[seat.Key] = mapFn(seat);
        }
      }
      return reduced;
    },
    sectionHasRow: function sectionHasRow(section, row) {
      return self.hasSection(section) && self.getSection(section).hasRow(row);
    },
    sectionRowHasSeat: function sectionRowHasSeat(section, row, seat) {
      return self.sectionHasRow(section, row) && self.getRow(section, row).hasSeat(seat);
    },
    seatIsSelected: function seatIsSelected(seat) {
      return self.selectedSeats.has(seat);
    }
  };
}).actions(function (self) {
  return {
    /**
     *
     * @param {*} section
     * @param {*} rows
     */
    addRows: function addRows(section) {
      var rows = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      if (!self.hasSection(section)) {
        self.addSection({
          Key: section
        });
      }
      return self.getSection(section).addRows(rows);
    },
    addSections: function addSections() {
      var sections = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      self.Sections.save(sections, function (section, add) {
        return add(section.Key, section);
      });
    },
    addSection: function addSection(section) {
      self.Sections.add(section.Key, section);
    },
    clearSections: function clearSections() {
      self.Sections.clear();
    },
    clearSelected: function clearSelected() {
      self.clearSelectedSeats();
      self.clearSelectedRows();
      self.clearSelectedSections();
    },
    clearSelectedSections: function clearSelectedSections() {
      self.selectedSections.clear();
    },
    clearSelectedSeats: function clearSelectedSeats() {
      self.selectedSeats.clear();
    },
    clearSelectedRows: function clearSelectedRows() {
      self.selectedRows.clear();
    },
    deselectSeat: function deselectSeat(seat) {
      self.selectedSeats["delete"](seat);
    },
    selectSection: function selectSection(section) {
      self.selectedSections.set(section, section);
    },
    selectSeat: function selectSeat(seat) {
      self.selectedSeats.set(seat, seat);
    },
    selectRow: function selectRow(row) {
      self.selectedRows.set(row, row);
    },
    setFocusedSectionKey: function setFocusedSectionKey(section) {
      self.focusedSectionKey = section;
    },
    setFocusedSeatKey: function setFocusedSeatKey(section, row, seat) {
      self.focusedSectionKey = section;
      self.focusedRowKey = row;
      self.focusedSeatKey = seat;
    },
    toggleSelectedSeat: function toggleSelectedSeat(seat) {
      if (self.selectedSeats.has(seat)) {
        self.deselectSeat(seat);
        return undefined;
      }
      self.selectSeat(seat);
      return seat;
    },
    unfocusSectionKey: function unfocusSectionKey() {
      self.focusedSectionKey = undefined;
    },
    unfocusSeatKey: function unfocusSeatKey() {
      self.focusedSeatKey = undefined;
    }
  };
});

/**
 * PaymentProcess Model
 * Represents a payment processor as specified by the ts api
 */
var PaymentProcess = types.model({
  UseSandbox: false,
  AccountId: types.maybeNull(types.string),
  TestKey: types.maybeNull(types.string),
  LiveKey: types.maybeNull(types.string),
  Name: types.maybeNull(types.string)
}).preProcessSnapshot(function () {
  var snapshot = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread2({}, snapshot);
}).views(function (self) {
  return {
    get locationId() {
      return self.AccountId;
    },
    get applicationId() {
      return self.UseSandbox ? self.TestKey : self.LiveKey;
    },
    get isReady() {
      return (self.TestKey || self.LiveKey) && self.Name;
    }
  };
}).actions(function (self) {
  return {
    updatePaymentProcessInfo: function updatePaymentProcessInfo(_ref) {
      var UseSandbox = _ref.UseSandbox,
        TestKey = _ref.TestKey,
        LiveKey = _ref.LiveKey,
        Name = _ref.Name,
        AccountId = _ref.AccountId;
      self.UseSandbox = UseSandbox;
      self.TestKey = TestKey;
      self.LiveKey = LiveKey;
      self.Name = Name;
      self.AccountId = AccountId;
    }
  };
});

/**
 * UiTicket Model
 * A model describing a ticket for display
 */
var UiTicket = types.compose(Ticket, types.model({
  loading: false,
  errors: false
})).named('Ticket').actions(function (self) {
  return {
    setLoading: function setLoading() {
      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      self.loading = loading;
    },
    setErrors: function setErrors(e) {
      self.errors = e;
    }
  };
});

/**
 * Timer Model
 * Convenience model for starting stopping a timer and displaying the result
 */

// easy conversions from milliseconds
var ONE_SECOND = 1000;
var ONE_MINUTE = ONE_SECOND * 60;

/**
 * @note
 * for the sake of simplicity and also more accuracy, this timer will tick every second
 * if that becomes a performance issue, we can lengthen the inteval to be every minute
 * the reason why we don't do that now is because it requires us to use setTimeout instead
 * of setInterval.  This means that after every minute we need to cancel the timeout, clean it up,
 * and start a new timeout.  Additionally, once we reach the threshold that we want to we need to
 * decrease the interval.  Problems arise at this change of interval, because sometimes it does not
 * occur straign at 60 seconds.  For example, if we made it change at 5 minutes, there would be a
 * possibility that on the updated tick, the next displayed time would be 4:42 instead of 4:59 because
 * of how math works (meaning correct computations).  This introduces a weird corner case where we would
 * need to stop it a minute before we would want the interval to change to every second, but still show
 * it in minutes (ie "6 min remaining") until it reaches our threshold ("5 min remaining") which would then
 * change to ("4:59 remaining").  This is absolutely doable, but it complicates this relatively simple code
 * and may not even bring that much performance benefits.  That's why I have opted to keep it implemented
 * as is:
 *
 * - The Official Joseph Caluza™
 */
var Timer = types.model({
  // number of milliseconds the cart timer should be active
  duration: 0,
  // the timer to be cleared
  timerId: types.maybe(types.number)
}).named('Timer')["volatile"](function (self) {
  return {
    initialized: false,
    interval: ONE_SECOND
  };
}).views(function (self) {
  return {
    get isExpired() {
      return self.duration <= 0;
    },
    get timeConversions() {
      var totalMilliseconds = self.duration;
      // don't want to divide by 0
      var totalSeconds = self.isExpired ? 0 : self.duration / ONE_SECOND;
      var totalMinutes = self.isExpired ? 0 : self.duration / ONE_MINUTE;
      return {
        totalMilliseconds: totalMilliseconds,
        totalSeconds: totalSeconds,
        totalMinutes: totalMinutes
      };
    },
    get timeRemaining() {
      var _self$timeConversions = self.timeConversions,
        minutes = _self$timeConversions.totalMinutes,
        totalSeconds = _self$timeConversions.totalSeconds,
        totalMilliseconds = _self$timeConversions.totalMilliseconds;
      // if there is more than one minute in milliseconds
      // 		seconds remaining is the total milliseconds mod one minute
      // else
      // 		seconds remaining is the total seconds
      var seconds = (totalMilliseconds > ONE_MINUTE ? totalMilliseconds % ONE_MINUTE : totalSeconds) / 1000;
      return {
        minutes: minutes,
        seconds: seconds
      };
    }
  };
}).actions(function (self) {
  return {
    startTimer: function startTimer(duration, onTick) {
      if (!self.initialized) {
        self.duration = duration;
        var timerId = setInterval(function () {
          return self.tick(onTick);
        }, self.interval);
        self.timerId = timerId;
        self.initialized = true;
      }
    },
    tick: function tick() {
      var onTick = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
        return undefined;
      };
      self.decreaseDuration();
      if (self.isExpired) self.cancelTimer();
      onTick(self.duration, self.isExpired);
    },
    decreaseDuration: function decreaseDuration() {
      self.duration -= self.interval;
    },
    cancelTimer: function cancelTimer() {
      clearInterval(self.timerId);
      self.initialized = false;
      self.timerId = undefined;
      self.duration = 0;
    }
  };
});

var SUPPORTED_LOCALES = ['en-us', 'ja-jp', 'ko-kr', 'fr-ca'];

/**
 * LanguageLocale Model
 * Stores information about the site language codes
 */
var LanguageLocale = types.model({
  Locale: types.maybe(types.refinement(types.string, function (lang) {
    return SUPPORTED_LOCALES.indexOf(lang.toLowerCase()) > -1;
  })),
  DefaultLanguageSelection: types.maybe(types.string)
}).named('LanguageLocale');

/**
 * CurrencyLocale Model
 * Represents a site currency code info
 */
var CurrencyLocale = types.model({
  Code: types.maybe(types.string),
  Symbol: types.maybe(types.string)
}).named('CurrencyLocale');

/**
 * Localization Model
 * Stores info needed for i18n and l10n
 */
var Localization = types.model({
  Currency: types.maybe(CurrencyLocale),
  Language: types.maybe(LanguageLocale)
}).named('Localization').views(function (self) {
  return {
    get priceDisplay() {
      return {
        locale: self.Language.Locale,
        options: {
          style: 'currency',
          currency: self.Currency.Code
        }
      };
    },
    getPriceDisplayWithDigits: function getPriceDisplayWithDigits() {
      var minimumFractionDigits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;
      return {
        locale: self.Language.Locale,
        options: {
          style: 'currency',
          currency: self.Currency.Code,
          minimumFractionDigits: minimumFractionDigits
        }
      };
    }
  };
});

/**
 * LegacyAppearanceSettings Model
 * Represents site appearance based on the ts api
 * @note will be deprecated in the future
 */
var LegacyAppearanceSettings = types.model({
  LinkColor: types.maybeNull(types.string),
  AccentColor: types.maybeNull(types.string)
}).named('LegacyAppearanceSettings').views(function (self) {
  return {
    get brandColor() {
      return self.LinkColor;
    },
    get accentColor() {
      return self.AccentColor;
    }
  };
});

var _excluded$2 = ["Settings"];
var SiteInfo = types.model({
  Name: '',
  FavIcon: types.maybeNull(Photo),
  Localization: types.maybe(Localization),
  Logo: types.maybeNull(Photo),
  Categories: types.maybeNull(types.array(types.map(types.string))),
  Venues: types.maybeNull(types.array(VenueInfo)),
  CheckoutWidget: types.maybeNull(types.array(LegacyAppearanceSettings)),
  PolicySettings: types.maybeNull(types.map(types.maybeNull(types.string)))
}).named('SiteInfo')["volatile"](function (self) {
  return {
    initialized: false
  };
}).views(function (self) {
  return {
    get json() {
      return self.toJSON();
    },
    get appearanceSettings() {
      return (self.CheckoutWidget || [])[0];
    }
  };
}).actions(function (self) {
  return {
    __applySettings: function __applySettings(_ref) {
      var CheckoutWidget = _ref.CheckoutWidget,
        PolicySettings = _ref.PolicySettings;
      self.CheckoutWidget = CheckoutWidget;
      self.PolicySettings = PolicySettings;
    },
    __applyLocalization: function __applyLocalization(localization) {
      self.Localization = localization;
    },
    setInfo: function setInfo(_ref2) {
      var Settings = _ref2.Settings,
        info = _objectWithoutProperties(_ref2, _excluded$2);
      try {
        var Currency = Settings.Currency,
          Locale = Settings.Locale,
          DefaultLanguageSelection = Settings.DefaultLanguageSelection;
        self.__applySettings(Settings);
        self.__applyLocalization({
          Currency: Currency,
          Language: {
            Locale: Locale,
            DefaultLanguageSelection: DefaultLanguageSelection
          }
        });
        Object.keys(info).forEach(function (key) {
          if (!self.json.hasOwnProperty(key)) return;
          self[key] = info[key];
          return;
        });
        self.initialized = true;
      } catch (e) {
        self.initialized = false;
        throw new Error(e);
      }
    }
  };
});

var DEFAULT_PAGING = {
  Take: 6,
  Skip: 0,
  Total: 0
};
/**
 * Paging Model
 * Keeps track of how many items are showing and how many to get for the next page
 */
var Paging = makeCollection2(types.number).views(function (self) {
  return {
    get Skip() {
      return self.record.Skip;
    },
    get Take() {
      return self.record.Take;
    },
    get Total() {
      return self.record.Total;
    }
  };
}).actions(function (self) {
  return {
    updateSkip: function updateSkip(skip) {
      self.add('Skip', parseInt(skip));
      return skip;
    },
    updateTake: function updateTake(take) {
      self.add('Take', parseInt(take));
      return take;
    },
    updateTotal: function updateTotal(total) {
      self.add('Total', parseInt(total));
      return total;
    },
    reset: function reset() {
      self.replace(DEFAULT_PAGING);
    },
    next: function next() {
      var next = self.get('Skip') + self.get('Take');
      self.updateSkip(next);
    }
  };
});

/**
 * Filters Model
 * Keeps track of filter state
 *
 * @note this is an MST map which would allow us to add a filters on the fly instead of
 * adhering to hard coded ones.  However, I think it might be easier to have clearly defined filters instead of adding them dynamically.
 * It might be more beneficial to create more primitive models (like `DateRange`) and create different "filter sets" made from those primitives.
 * This would allow for more re-usability while also allowing us to create tailored filters for each use case since there is not much variance
 * in the ways we use filters in our apps
 */

/**
 * @note there may be benefit to replacing From and To with a `DateRange` model (see DateRange model).  For simplicity, I am
 * keeping them as regular strings because the use case may be a bit different even though the properties are similar
 */
var Filters = makeCollection2(types.string).actions(function (self) {
  return {
    updateTitle: function updateTitle(title) {
      self.add('Title', title);
    },
    updateFromDate: function updateFromDate(date) {
      self.add('From', date);
    },
    updateToDate: function updateToDate(date) {
      self.add('To', date);
    },
    updateDateRange: function updateDateRange(from, to) {
      self.updateFromDate(from);
      self.updateToDate(to);
    },
    clearDates: function clearDates() {
      self["delete"]('From');
      self["delete"]('To');
    },
    clearTitle: function clearTitle() {
      self["delete"]('Title');
    },
    clearAll: function clearAll() {
      self.clearDates();
      self.clearTitle();
    }
  };
});

// set up the cache
var EventsCache = makeCollection2(Event).named('EventsCache');

/**
 * EventCollection Model
 * Caches eventsand provides an interface to display a subset of events
 */
var EventCollection = types.model({
  EventsCache: EventsCache,
  Filters: Filters,
  Paging: Paging,
  EventsCollection: types.array(types.reference(Event))
}).named('EventsCollection').preProcessSnapshot(function () {
  var snapshot = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread2(_objectSpread2({}, snapshot), {}, {
    EventsCache: snapshot.EventsCache || {},
    Filters: snapshot.Filters || {},
    Paging: snapshot.Paging || {},
    EventsCollection: snapshot.EventsCollection || []
  });
}).views(function (self) {
  return {
    get listOfEvents() {
      return self.EventsCollection;
    },
    get listIsEmpty() {
      return self.EventsCollection.length === 0;
    },
    mapEventsById: function mapEventsById(events) {
      return events.reduce(function (map, event) {
        return _objectSpread2(_objectSpread2({}, map), {}, _defineProperty({}, event.Id, event));
      }, {});
    },
    findEventBySlug: function findEventBySlug(slug) {
      return self.EventsCollection.find(function (event) {
        return event.UrlSlug === slug;
      });
    },
    getEventByIdOrSlug: function getEventByIdOrSlug(IdOrSlug) {
      return self.EventsCache.get(IdOrSlug) || self.findEventBySlug(IdOrSlug);
    }
  };
}).actions(function (self) {
  return {
    /**
     * For internal use only.  Used to record to the Event Cache
     * @deprecated
     * @param {*} event an Event to record
     * @param {function} set the function that sets the value
     */
    __recorder: function __recorder(event, set) {
      set(event.Id, event);
    },
    /**
     * Updates the current Event Cache
     * @param {*[]} events an array of events to update the Event Cache with
     */
    cache: function cache(events) {
      var eventMap = self.mapEventsById(events);
      self.EventsCache.merge(eventMap);
    },
    /**
     * Empties the current Event Cache
     */
    clearCache: function clearCache() {
      self.EventsCache.clear();
    },
    /**
     * Updates the current Event Collection
     * @param {*[]} events an array of events to update the collection with
     * @param {Boolean} [replace = false] if true, will completely replace current events in the collection with the new events
     */
    updateList: function updateList(events) {
      var replace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      self.cache(events);
      var references = events.map(function (_ref) {
        var Id = _ref.Id;
        return Id;
      });
      if (replace) {
        self.EventsCollection.replace(references);
      } else {
        references.forEach(function (reference) {
          return self.EventsCollection.push(reference);
        });
      }
    },
    /**
     * Empties the current Event Collection
     */
    clearList: function clearList() {
      self.EventsCollection.clear();
    },
    /**
     * Updates the Paging total
     * @param {Number} total the gross amount of events
     */
    updateTotal: function updateTotal(total) {
      self.Paging.updateTotal(total);
    },
    /**
     * Updates the title being filtered by
     * @param {String} title the title to filter by
     */
    updateTitle: function updateTitle(title) {
      self.Filters.updateTitle(title);
    }
  };
});

/**
 * IcsEntityMetaData Model
 * Common meta data for an entity created with the ics api
 */
var IcsEntityMetaData = types.model({
  id: types.identifier,
  status: types.maybe(types.string),
  isArchived: types.maybe(types["boolean"]),
  createdAt: types.maybe(IsoDate),
  updatedAt: types.maybe(IsoDate)
}).named('IcsEntityMetaData').preProcessSnapshot(function (snapshot) {
  if (snapshot === null || snapshot === undefined) return null;
  var createdAt = snapshot.createdAt,
    updatedAt = snapshot.updatedAt;
  var correctedCreatedAt = correctDate(createdAt);
  var correctedUpdatedAt = correctDate(updatedAt);
  return _objectSpread2(_objectSpread2({}, snapshot), {}, {
    id: snapshot.id === null ? snapshot.id : "".concat(snapshot.id),
    createdAt: correctedCreatedAt,
    updatedAt: correctedUpdatedAt
  });
});
function correctDate() {
  var snapshotVal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (typeof snapshotVal === 'string' || typeof (snapshotVal || {}).raw === 'string') {
    return snapshotVal;
  }
  return undefined;
}

/**
 * IcsUser Model
 * Ics user as represented by the ics api
 */
var IcsUser = types.compose(IcsEntityMetaData, types.model({
  email: types.maybeNull(types.string),
  // Required
  firstName: types.maybeNull(types.string),
  // Required
  lastName: types.maybeNull(types.string),
  // Required
  role: types.maybeNull(types.string),
  // Required
  business: types.maybeNull(types.number),
  // Required
  affiliateId: types.maybeNull(types.string),
  // Required (or clientId)
  affiliateName: types.maybeNull(types.string),
  // Required (or clientId)
  clientId: types.maybeNull(types.string),
  // Required (or affiliateId)
  clientName: types.maybeNull(types.string),
  // Required (or affiliateId)
  isTeamAdmin: types.maybeNull(types["boolean"]),
  // Required
  isSuperUser: types.maybeNull(types["boolean"]),
  ip: types.optional(types.maybeNull(types.array(types.string)), [])
})).named('IcsUser').preProcessSnapshot(function () {
  var snapshot = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread2(_objectSpread2({}, snapshot), {}, {
    affiliateId: snapshot.affiliateId === null ? snapshot.affiliateId : "".concat(snapshot.affiliateId),
    clientId: snapshot.clientId === null ? snapshot.clientId : "".concat(snapshot.clientId),
    ip: Array.isArray(snapshot.ip) ? snapshot.ip : typeof snapshot.ip === 'string' && snapshot.ip[0] === '{' && snapshot.ip[snapshot.length - 1] === '}' ? snapshot.ip.substr(0, snapshot.ip.length - 1).substr(1).split(',') : null
  });
}).views(function (self) {
  return {
    get name() {
      return self.firstName ? "".concat(self.firstName, " ").concat(self.lastName) : self.email;
    },
    get initials() {
      return "".concat(self.firstName.charAt(0)).concat(self.lastName.charAt(0));
    }
  };
}).actions(function (self) {
  return {
    // this is here because the company field in the API is deprecated and this is the easiest place to keep track of it for now
    setBusiness: function setBusiness(business) {
      self.business = business;
    }
  };
});

types.model({
  segmentName: types.string,
  segmentType: types.enumeration('segmentName', ['Vertical', 'SubCategory']),
  id: types.union(types.number, types.string)
}).named('Segment');
/**
 * IcsCompany Model
 * A company as represented by the ics api
 */
var IcsCompany = types.compose(IcsEntityMetaData, types.model({
  clientId: types.maybeNull(types.string),
  name: types.maybeNull(types.string),
  emailAddress: types.maybeNull(types.string),
  businessAddress: types.maybeNull(types.string),
  supportEmail: types.maybeNull(types.string),
  logo: types.maybeNull(types.string),
  cardFlexSecurityKey: types.maybeNull(types.string),
  isConfigured: false,
  currency: types.maybeNull(types.string),
  language: types.maybeNull(types.string),
  eCommerceSolution: types.maybeNull(types.string),
  webstoreURL: types.maybeNull(types.string),
  maskInfo: types.maybeNull(types["boolean"]),
  privacyPolicyURL: types.maybeNull(types.optional(types.string, '')),
  termsAndConditionsURL: types.maybeNull(types.optional(types.string, '')),
  processorId: types.maybeNull(types.string)
  // marketVertical: types.maybeNull(types.union(Segment, types.number, types.string)),
  // marketSubCategory: types.maybeNull(types.union(Segment, types.number, types.string)),
})).named('IcsCompany').views(function (self) {
  return {
    get isProfileComplete() {
      var name = self.name,
        businessAddress = self.businessAddress,
        termsAndConditionsURL = self.termsAndConditionsURL,
        privacyPolicyURL = self.privacyPolicyURL,
        currency = self.currency,
        language = self.language;
      return !!name && !!businessAddress &&
      // !!marketVertical &&
      !!termsAndConditionsURL && !!privacyPolicyURL && !!currency && !!language;
    },
    get isEcommereceComplete() {
      var eCommerceSolution = self.eCommerceSolution,
        webstoreURL = self.webstoreURL;
      return !!eCommerceSolution && !!webstoreURL;
    },
    get isBrandComplete() {
      var logo = self.logo;
      return !!logo;
    },
    get isSetupComplete() {
      return self.isProfileComplete && self.isEcommereceComplete && self.isBrandComplete;
    }
  };
});

// processorId: 4;

/**
 * IcsClient Model
 * Client as represented by the ics api
 */
var IcsClient = types.compose(IcsEntityMetaData, types.model({
  name: types.maybeNull(types.string),
  publicKey: types.maybeNull(types.string),
  regenKey: types.maybeNull(types.string),
  affiliateId: types.maybeNull(types.string),
  affiliateName: types.maybeNull(types.string),
  campaignCount: types.maybeNull(types.string),
  campaignSID: types.maybeNull(types.string),
  messageServiceSID: types.maybeNull(types.string),
  smsPhone: types.maybeNull(types.string),
  smsUseCaseStatus: types.maybeNull(types.enumeration(['PENDING', 'IN_PROGRESS', 'VERIFIED', 'FAILED'])),
  allowSMS: types.maybeNull(types["boolean"]),
  isArchived: types.maybeNull(types["boolean"])
})).named('IcsClient').preProcessSnapshot(function () {
  var snapshot = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread2(_objectSpread2({}, snapshot), {}, {
    affiliateId: snapshot.affiliateId === null ? snapshot.affiliateId : "".concat(snapshot.affiliateId)
  });
});

/**
 * IcsPaymentGateway Model
 * Payment gateway as represented by the ics api
 */
var IcsPaymentGateway = types.compose(IcsEntityMetaData, types.model({
  authorizenetApiLoginKey: types.maybeNull(types.string),
  authorizenetTransactionKey: types.maybeNull(types.string),
  cardFlexSecurityKey: types.maybeNull(types.string),
  clientId: types.maybeNull(types.string),
  companyId: types.maybeNull(types.string),
  type: types.maybeNull(types.string),
  name: types.maybeNull(types.string),
  squareAppId: types.maybeNull(types.string),
  squareLocationId: types.maybeNull(types.string),
  squareLocationName: types.maybeNull(types.string),
  squareAppAccessToken: types.maybeNull(types.string),
  squareOAuthAccessToken: types.maybeNull(types.string),
  squareOAuthAccessTokenExpiration: types.maybeNull(types.string),
  squareOAuthRefreshToken: types.maybeNull(types.string),
  squareMerchantId: types.maybeNull(types.string),
  stripeAccessToken: types.maybeNull(types.string),
  stripeAccountId: types.maybeNull(types.string),
  stripePublishKey: types.maybeNull(types.string),
  stripeRefreshToken: types.maybeNull(types.string)
})).named('IcsPaymentGateway');

/**
 * IcsStat Model
 * A stat as represented by the ics api
 */
var IcsStat = types.model({
  date: types.maybeNull(types.string),
  totalConversions: 0,
  totalInvitesClicked: 0,
  totalInfluencers: 0,
  totalRevenue: 0,
  totalUtilizationRate: 0,
  totalUtilizedInfluencers: 0
}).named('IcsStat').preProcessSnapshot(function () {
  var snapshot = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    date: snapshot.date || null,
    totalConversions: parseInt(snapshot.totalConversions) || 0,
    totalInvitesClicked: parseInt(snapshot.totalInvitesClicked) || 0,
    totalInfluencers: parseInt(snapshot.totalInfluencers) || 0,
    totalRevenue: parseInt(snapshot.totalRevenue) || 0,
    totalUtilizationRate: parseInt(snapshot.totalUtilizationRate) || 0,
    totalUtilizedInfluencers: parseInt(snapshot.totalUtilizedInfluencers) || 0
  };
});

/**
 * IcsAffiliate Model
 * An affiliate as represented by the ics api
 */
var IcsAffiliate = types.compose(IcsEntityMetaData, types.model({
  name: types.maybeNull(types.string),
  parentId: types.maybeNull(types.string),
  parentName: types.maybeNull(types.string),
  clientCount: types.maybeNull(types.string),
  campaignCount: types.maybeNull(types.string)
})).named('IcsAffiliate').preProcessSnapshot(function () {
  var snapshot = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread2(_objectSpread2({}, snapshot), {}, {
    parentId: snapshot.parentId === null ? snapshot.parentId : "".concat(snapshot.parentId)
  });
});

var _excluded$1 = ["id", "processorId"];

/**
 * IcsCampaign Model
 * A campaign as represented by the ics api
 */
var IcsCampaign$1 = types.model({
  id: types.identifier,
  name: types.maybeNull(types.string),
  fromEmail: types.maybeNull(types.string),
  fromName: types.maybeNull(types.string),
  emailSubject: types.maybeNull(types.string),
  active: types.maybeNull(types["boolean"]),
  conversionGoal: types.maybeNull(types.number),
  offerHeading: types.maybeNull(types.string),
  offerInstructions: types.maybeNull(types.string),
  shareMessage: types.maybeNull(types.string),
  thankYouImage: types.maybeNull(types.string),
  redirectUrl: types.maybeNull(types.string),
  offerImage: types.maybeNull(types.string),
  userId: types.maybeNull(types.number),
  createdAt: types.maybeNull(types.string),
  updatedAt: types.maybeNull(types.string),
  thankYouImageMobile: types.maybeNull(types.string),
  offerImageMobile: types.maybeNull(types.string),
  shareImage: types.maybeNull(types.string),
  shareTitle: types.maybeNull(types.string),
  locale: types.optional(types.maybeNull(types.string), 'en-US'),
  offerImageCaption: types.maybeNull(types.string),
  offerImageTitle: types.maybeNull(types.string),
  shareVideo: types.maybeNull(types.string),
  clientId: types.maybeNull(types.number),
  maskInfo: types.maybeNull(types["boolean"]),
  isArchived: types.maybeNull(types["boolean"]),
  emailNote: types.maybeNull(types.string),
  status: types.maybeNull(types.string),
  termsAndConditionsURL: types.maybeNull(types.string),
  privacyPolicyURL: types.maybeNull(types.string),
  refundFullAmount: types.maybeNull(types["boolean"]),
  refundAmount: types.maybeNull(Price),
  useCardFlexRefund: types.maybeNull(types["boolean"]),
  cardFlexManualRefund: types.maybeNull(types["boolean"]),
  clientName: types.maybeNull(types.string),
  giftCardAmount: types.maybeNull(types.number),
  isManual: types.maybeNull(types["boolean"]),
  processingAmount: types.maybeNull(Price),
  processorId: types.maybeNull(types.string),
  processorType: types.maybeNull(types.string),
  discountCode: types.maybeNull(types.string),
  discountCodeDesc: types.maybeNull(types.string),
  useSMS: false,
  useSMSConsent: false,
  useEmail: false,
  useEmailConsent: false
}).named('IcsCampaign').preProcessSnapshot(function (_ref) {
  var id = _ref.id,
    processorId = _ref.processorId,
    snap = _objectWithoutProperties(_ref, _excluded$1);
  return _objectSpread2(_objectSpread2({}, snap), {}, {
    id: "".concat(id),
    processorId: processorId ? "".concat(processorId) : null
  });
});

/**
 * IcsCampaign Model
 * A campaign as represented by the ics api
 */
var IcsCampaign = types.model({
  id: types.identifier,
  name: types.maybeNull(types.string),
  fromEmail: types.maybeNull(types.string),
  fromName: types.maybeNull(types.string),
  emailSubject: types.maybeNull(types.string),
  active: types.maybeNull(types["boolean"]),
  conversionGoal: types.maybeNull(types.number),
  offerHeading: types.maybeNull(types.string),
  offerInstructions: types.maybeNull(types.string),
  shareMessage: types.maybeNull(types.string),
  thankYouImage: types.maybeNull(types.string),
  redirectUrl: types.maybeNull(types.string),
  offerImage: types.maybeNull(types.string),
  userId: types.maybeNull(types.number),
  createdAt: types.maybeNull(types.string),
  updatedAt: types.maybeNull(types.string),
  thankYouImageMobile: types.maybeNull(types.string),
  offerImageMobile: types.maybeNull(types.string),
  shareImage: types.maybeNull(types.string),
  shareTitle: types.maybeNull(types.string),
  locale: types.optional(types.maybeNull(types.string), 'en-US'),
  offerImageCaption: types.maybeNull(types.string),
  offerImageTitle: types.maybeNull(types.string),
  shareVideo: types.maybeNull(types.string),
  clientId: types.maybeNull(types.number),
  maskInfo: types.maybeNull(types["boolean"]),
  isArchived: types.maybeNull(types["boolean"]),
  emailNote: types.maybeNull(types.string),
  status: types.maybeNull(types.string),
  termsAndConditionsURL: types.maybeNull(types.string),
  privacyPolicyURL: types.maybeNull(types.string),
  refundFullAmount: types.maybeNull(types["boolean"]),
  refundAmount: types.maybeNull(Price),
  useCardFlexRefund: types.maybeNull(types["boolean"]),
  cardFlexManualRefund: types.maybeNull(types["boolean"]),
  clientName: types.maybeNull(types.string),
  giftCardAmount: types.maybeNull(types.number),
  isManual: types.maybeNull(types["boolean"]),
  processingAmount: types.maybeNull(Price),
  processorId: types.maybeNull(types.string),
  processorType: types.maybeNull(types.string),
  discountCode: types.maybeNull(types.string),
  discountCodeDesc: types.maybeNull(types.string),
  useEmail: false,
  useEmailConsent: false,
  useSMS: false,
  useSMSConsent: false
}).named('IcsCampaign');

var _excluded = ["influencerLink", "transactionId"];
/**
 * IcsInfluencer Model
 * An influencer as represented by the ics api
 */
var IcsInfluencer = types.compose(IcsEntityMetaData, types.model({
  campaignId: types.maybeNull(types.number),
  conversionCount: types.maybeNull(types.number),
  conversionRevenue: types.maybeNull(types.number),
  email: types.maybeNull(types.string),
  emailConsent: types.maybeNull(types["boolean"]),
  mobileNumber: types.maybeNull(types.string),
  smsConsent: types.maybeNull(types["boolean"]),
  goalsReached: types.maybeNull(types.number),
  goalsProcessed: types.maybeNull(types.number),
  inviteCount: types.maybeNull(types.number),
  utilized: types.maybeNull(types.number),
  name: types.maybeNull(types.string),
  orderId: types.maybeNull(types.string),
  revenue: types.maybeNull(types.number),
  invitesClicked: types.maybeNull(types.number),
  rewardsDue: types.maybeNull(types.number),
  rewardsIssued: types.maybeNull(types.number),
  inviteLink: types.maybeNull(types.string),
  inviteResendsRemaining: types.maybeNull(types.number),
  resendAfterDate: types.string,
  signupConversions: types.maybeNull(types.number),
  participationConversions: types.maybeNull(types.number),
  pageViewConversions: types.maybeNull(types.number),
  shareConversions: types.maybeNull(types.number),
  facebook: types.maybeNull(types.number),
  emailChannel: types.maybeNull(types.number),
  messenger: types.maybeNull(types.number),
  kakao: types.maybeNull(types.number),
  wechat: types.maybeNull(types.number),
  sms: types.maybeNull(types.number),
  whatsapp: types.maybeNull(types.number),
  influencerLink: types.maybeNull(types.string),
  identifier: types.maybeNull(types.string),
  transactionId: types.maybeNull(types.string),
  isV2: types.maybeNull(types["boolean"])
})).named('IcsInfluencer').preProcessSnapshot(function (_ref) {
  var influencerLink = _ref.influencerLink,
    transactionId = _ref.transactionId,
    snap = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread2(_objectSpread2({}, snap), {}, {
    influencerLink: influencerLink ? "".concat(influencerLink) : null,
    transactionId: transactionId ? "".concat(transactionId) : null
  });
}).views(function (self) {
  return {
    get isProcessed() {
      var goalsProcessed = self.goalsProcessed,
        rewardsDue = self.rewardsDue,
        rewardsIssued = self.rewardsIssued;
      return rewardsDue === 0 && rewardsIssued > 0 || goalsProcessed > 0;
    },
    get isEligible() {
      var goalsReached = self.goalsReached,
        rewardsDue = self.rewardsDue;
      return rewardsDue > 0 || goalsReached > 0; // goals reached is for backwards compatibility.  will be phased out
    }
  };
});

/**
 * IcsInvite Model
 * An Invite as represented by the ICS API
 */
var IcsInvite = types.compose(IcsEntityMetaData, types.model({
  type: types.maybeNull(types.string),
  name: types.maybeNull(types.string),
  identifier: types.maybeNull(types.string),
  email: types.maybeNull(types.string),
  shareMessage: types.maybeNull(types.string),
  redirectUrl: types.maybeNull(types.string),
  convertedRevenue: types.maybeNull(Price),
  hasConversion: types.maybeNull(types["boolean"]),
  inviteClickCount: types.maybeNull(types.number),
  inviteResendsRemaining: types.maybeNull(types.number),
  resendAfterDate: types.maybeNull(types.string),
  influencerId: types.maybeNull(types.number),
  campaignId: types.maybeNull(types.number),
  sentCount: types.maybeNull(types.number),
  conversionCount: types.maybeNull(types.number)
})).named('IcsInvite');

var MaybeNothing = function MaybeNothing(type) {
  return types.union(types.maybeNull(type), types.maybe(type));
};

/**
 * SquareLocation Model
 * A square location as represented by the square api
 */
var SquareLocation = types.model({
  id: MaybeNothing(types.string),
  name: MaybeNothing(types.string),
  address: MaybeNothing(types.model({
    address_line_1: MaybeNothing(types.string),
    address_line_2: MaybeNothing(types.string),
    locality: MaybeNothing(types.string),
    administrative_district_level_1: MaybeNothing(types.string),
    postal_code: MaybeNothing(types.string),
    country: MaybeNothing(types.string)
  })),
  timezone: MaybeNothing(types.string),
  capabilities: MaybeNothing(types.array(types.string)),
  status: MaybeNothing(types.string),
  created_at: MaybeNothing(types.string),
  merchant_id: MaybeNothing(types.string),
  country: MaybeNothing(types.string),
  language_code: MaybeNothing(types.string),
  currency: MaybeNothing(types.string),
  business_name: MaybeNothing(types.string),
  type: MaybeNothing(types.string),
  business_hours: MaybeNothing(types.model({})),
  coordinates: MaybeNothing(types.model({
    latitude: MaybeNothing(types.number),
    longitude: MaybeNothing(types.number)
  })),
  mcc: MaybeNothing(types.string)
}).named('SquareLocation');

/**
 * IcsConversion Model
 * A conversion as represented by the ics api
 */
var IcsConversion = types.compose(IcsEntityMetaData, types.model({
  campaignId: types.maybeNull(types.number),
  identifier: types.maybeNull(types.string),
  influencerId: types.maybeNull(types.number),
  inviteId: types.maybeNull(types.number),
  invitedInfluencerEmail: types.maybeNull(types.string),
  invitedInfluencerId: types.maybeNull(types.number),
  invitedInfluencerName: types.maybeNull(types.string),
  revenue: types.maybeNull(types.number),
  transactionGateway: types.maybeNull(types.string),
  transactionId: types.maybeNull(types.string),
  conversionType: types.maybeNull(types.string)
})).named('IcsConversion')
// .preProcessSnapshot((snap) => ({}))
.views(function (self) {
  return {};
});

/**
 * IcsReward Model
 * A Reward as represented by the ICS API
 */
var IcsReward = types.compose(IcsEntityMetaData, types.model({
  name: types.maybeNull(types.string),
  identifier: types.maybeNull(types.string),
  rewardType: types.maybeNull(types.string),
  influencerEmail: types.maybeNull(types.string),
  rewardAmount: types.maybeNull(Price),
  influencerId: types.maybeNull(types.number),
  campaignId: types.maybeNull(types.number)
})).named('IcsReward')
// .preProcessSnapshot((snap) => ({}))
.views(function (self) {
  return {};
});

export { Address, AsyncApi, CacheControl, Cart, CreateAsyncActionsFlow as CreateAsyncFlow, CurrencyLocale, DateRange, Event, EventCollection, EventDescription, Fee, Filters, Form, IcsAffiliate, IcsCampaign$1 as IcsCampaign, IcsCampaign as IcsCampaignV2, IcsClient, IcsCompany, IcsConversion, IcsEntityMetaData, IcsInfluencer, IcsInvite, IcsPaymentGateway, IcsReward, IcsStat, IcsUser, Input, IsoDate, LanguageLocale, LegacyAppearanceSettings, Localization, MinimalId, Notification, NotificationHandler, Paging, PaymentProcess, Photo, Price, PriceRange, PromoCode, PublishingOptions, PurchaserInfo, Row, Seat, Seat2, SeatMetaInfo, SeatSelection, Section, Section2, SectionMetaInfo, SiteInfo, SquareLocation, Ticket, Timer, UiTicket, Venue, VenueInfo, VenueOrchestrator, createCollection, makeCollection2 as makeCollection };
